<script setup>
import EmployeeItem from "@/views/employee/EmployeeItem.vue";
</script>

<template>
  <EmployeeItem read-only />
</template>
